<!-- src/components/CustomToast.vue -->
<template>
  <div class="ct-card">
    <div class="ct-icon">📬</div>
    <div class="ct-content">
      <div class="ct-title">{{ subject || "Nouveau message" }}</div>
      <div class="ct-preview" v-if="preview">{{ preview }}</div>
      <div class="ct-meta" v-if="at">{{ formattedTime }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  subject?: string;
  preview?: string;
  at?: number | string;
}
const props = defineProps<Props>();

const formattedTime = computed(() => {
  if (!props.at) return "";
  const d = typeof props.at === "number" ? new Date(props.at) : new Date(props.at);
  return isNaN(d.getTime()) ? "" : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
});
</script>

<style scoped>
.ct-card{
  display:flex; gap:12px; align-items:flex-start;
  padding:14px 16px;
  border-radius:16px;
  background: linear-gradient(135deg, #111827, #1f2937);
  color:#fff;
  box-shadow: 0 10px 24px rgba(0,0,0,.35);
}
.ct-icon{ font-size: 22px; }
.ct-title{ font-weight: 700; font-size: 15px; line-height: 1.2; }
.ct-preview{ font-size: 13px; opacity: .9; margin-top:3px; }
.ct-meta{ font-size: 12px; opacity:.7; margin-top: 4px; }
</style>